(() => {
  const params = new URLSearchParams(window.location.search);
  const trackingParams = ['utm_source','utm_medium','utm_campaign','utm_term','utm_content','gclid','fbclid'];
  let hasParams = false;
  let storedParams = {};

  trackingParams.forEach(param => {
    if (params.has(param)) {
      storedParams[param] = params.get(param);
      hasParams = true;
    }
  });

  if (hasParams) {
    localStorage.setItem('okm_url_params', JSON.stringify(storedParams));
  }
})();